/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './document-service.pb';
import * as shared000 from '../../../../src/main/proto/shared/reaction.pb';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as shared002 from '../../../../src/main/proto/shared/document-shared.pb';
import { GRPC_DOCUMENT_SERVICE_CLIENT_SETTINGS } from './document-service.pbconf';
/**
 * Service client implementation for api.document.DocumentService
 */
@Injectable({ providedIn: 'any' })
export class DocumentServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /api.document.DocumentService/GetMetadta
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetMetadataResponse>>
     */
    getMetadta: (
      requestData: thisProto.GetMetadataRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetMetadataResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.document.DocumentService/GetMetadta',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetMetadataRequest,
        responseClass: thisProto.GetMetadataResponse
      });
    },
    /**
     * Unary call: /api.document.DocumentService/SetReaction
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SetReactionResponse>>
     */
    setReaction: (
      requestData: thisProto.SetReactionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SetReactionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.document.DocumentService/SetReaction',
        requestData,
        requestMetadata,
        requestClass: thisProto.SetReactionRequest,
        responseClass: thisProto.SetReactionResponse
      });
    },
    /**
     * Unary call: /api.document.DocumentService/UpdateComment
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UpdateCommentResponse>>
     */
    updateComment: (
      requestData: thisProto.UpdateCommentRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UpdateCommentResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.document.DocumentService/UpdateComment',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateCommentRequest,
        responseClass: thisProto.UpdateCommentResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_DOCUMENT_SERVICE_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'api.document.DocumentService',
      settings
    );
  }

  /**
   * Unary call @/api.document.DocumentService/GetMetadta
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetMetadataResponse>
   */
  getMetadta(
    requestData: thisProto.GetMetadataRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetMetadataResponse> {
    return this.$raw
      .getMetadta(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.document.DocumentService/SetReaction
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SetReactionResponse>
   */
  setReaction(
    requestData: thisProto.SetReactionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SetReactionResponse> {
    return this.$raw
      .setReaction(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.document.DocumentService/UpdateComment
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UpdateCommentResponse>
   */
  updateComment(
    requestData: thisProto.UpdateCommentRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UpdateCommentResponse> {
    return this.$raw
      .updateComment(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
